import React, { Component } from 'react'
import { Modal, message } from 'antd'

export default class extends Component {
  state = {
    isFetching: false
  }

  handleOk = (e) => {
    this.setState({
      isFetching: true
    })

    const id = this.props.table.keys[0]
    const ids = {
      ids: this.props.table.keys.map(String)
    }

    if (this.props.table.keys.length === 1) {
      this.props.deleteUserById(id)
        .then((response) => {
          this.props.updateTable({
            keys: [],
            rows: []
          })
          this.handleCancel()
          this.props.getDivisions()
        })
        .catch(error => {
          message.error(error.response.data.error.message)
          this.handleCancel()
        })
    } else if (this.props.table.keys.length > 1) {
      this.props.deleteUsersByArray(ids)
        .then((response) => {
          this.props.updateTable({
            keys: [],
            rows: []
          })
          this.handleCancel()
          this.props.getDivisions()

          if (ids.ids.map(id => Number(id)).includes(this.props.user.info.id)) {
            message.error('Current User profile cannot be deleted')
          }
        })
    }
  }

  handleCancel = (e) => {
    this.setState({
      isFetching: false
    })

    this.props.closeModal()
  }

  render () {
    const { isFetching } = this.state

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        width={320}
        visible={this.props.status}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        okText={'Delete'}
        okButtonProps={{ loading: isFetching }}
        okType={'red'}
        destroyOnClose
      >
        <h4>Are you sure you want to delete { this.props.table.keys.length > 1 ? 'these users' : 'this user' }?</h4>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/UserDeleteModal/UserDeleteModal.jsx